import { render } from "./TheTienDoGiaiNgan.vue?vue&type=template&id=7aa9bad5"
import script from "./TheTienDoGiaiNgan.vue?vue&type=script&lang=js"
export * from "./TheTienDoGiaiNgan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__